export const bookingCharges = {
  header: {
    title: "Cobranças",
    titleNew: "Novas cobranças",
    sub: "Itens a incluir na fatura do hóspede.",
    subNew:
      "Para a próxima fatura. A acomodação já faturada é exibida acima, na respectiva fatura.",
  },
  loading: "Carregando cobranças…",
  empty: {
    title: "Nenhuma cobrança registrada",
    titleBilled: "Nenhuma cobrança pendente",
    sub: "Adicione acomodação, limpeza, extras ou outros serviços.",
    subBilled: "Adicione uma cobrança para criar outra fatura para esta reserva.",
  },
  buttons: {
    addCharge: "Adicionar cobrança",
    addFirstCharge: "Adicionar primeira cobrança",
    manage: "Gerenciar",
    manageTemplatesTitle: "Gerenciar modelos",
    add: "Adicionar",
    close: "Fechar",
    cancel: "Cancelar",
    saving: "Salvando…",
    saveCharge: "Salvar cobrança",
    saveChanges: "Salvar alterações",
    deleting: "Excluindo…",
    confirmDelete: "Sim, excluir",
    editTitle: "Editar",
    deleteTitle: "Excluir",
  },
  table: {
    item: "Item",
    qty: "Qtd",
    unitPrice: "Preço unitário",
    vat: "VAT",
    total: "Total",
  },
  chips: {
    lodging: "Acomodação",
    discount: "Desconto",
    autoSynced: "Sincronizado automaticamente",
  },
  // Resumen de la estancia bajo cada habitación.
  stay: {
    nights: "1 noite | {n} noites",
    rooms: "1 quarto | {n} quartos",
  },

  fields: {
    // De qué habitación es el cargo (reservas de varias habitaciones).
    room: "Quarto",
    roomAll: "A reserva inteira",
    roomHint: "Se for de um quarto, irá na fatura desse quarto.",
    date: "Data",
    category: "Categoria",
    quantity: "Quantidade",
    unitPriceFull: "Preço unitário",
    vatPct: "VAT (%)",
    name: "Nome",
    price: "Preço",
    internalNotes: "Notas internas",
    paymentMethod: "Forma de pagamento",
    paymentDate: "Data do pagamento",
    guestCount: "Número de hóspedes",
  },
  placeholders: {
    item: "Selecione ou digite um item…",
    egCleaning: "ex.: Limpeza",
    internalNote: "Adicionar nota interna…",
  },
  templates: {
    savedTitle: "Cobranças salvas",
    noResults: 'Nenhum resultado para "{query}"',
    emptyPre: "Nenhuma cobrança salva. ",
    createOne: "Criar uma",
    manageTitle: "Cobranças personalizadas",
    manageSub: "Crie cobranças reutilizáveis para suas faturas.",
    emptyList: "Nenhuma cobrança salva. Adicione a primeira acima.",
    noCategory: "Sem categoria",
  },
  vat: {
    labelPct: "VAT {rate}%",
  },
  modal: {
    editTitle: "Editar cobrança",
    addSub: "Novo item para a fatura",
    editSub: "Editar os detalhes da cobrança",
    totalCalculated: "Total calculado",
  },
  common: {
    optional: "(opcional)",
    unspecified: "Não especificado",
  },
  invoice: {
    sectionLabel: "Fatura eletrônica",
  },
  footer: {
    pending: "Faturamento pendente",
    totalDue: "Total a pagar",
  },
  deleteModal: {
    title: "Excluir cobrança?",
    sub: "Esta ação não pode ser desfeita.",
  },
  autoCategory: {
    service: "Serviço",
    fee: "Taxa",
    extraGuest: "Hóspede extra",
    tax: "Imposto",
    cityTax: "Taxa municipal",
    adjustment: "Ajuste",
    autoFallback: "Cobrança automática",
  },
  chargeBasis: {
    percentOfTotal: "Porcentagem do total",
    perNight: "Por noite",
    perPerson: "Por pessoa",
    perPersonPerNight: "Por pessoa por noite",
    perStay: "Por reserva",
  },
  toast: {
    descRequired: "A descrição é obrigatória.",
    chargeAdded: "Cobrança adicionada.",
    chargeUpdated: "Cobrança atualizada.",
    chargeDeleted: "Cobrança excluída.",
    chargeSaved: "Cobrança salva.",
    saveFailed: "Não foi possível salvar.",
    deleteFailed: "Não foi possível excluir.",
    warningTitle: "Atenção",
    doneTitle: "Concluído",
    errorTitle: "Erro",
  },
  invoices: {
    title: "Faturas emitidas",
    noName: "Sem nome",
    conceptCount: "{count} item | {count} itens",
    viewPdf: "Ver PDF",
    sendWhatsapp: "Enviar pelo WhatsApp",
    correct: "Corrigir (retificadora)",
    void: "Anular (fatura retificativa)",
    conceptsFoot:
      "Estes itens já estão faturados. O PDF tem o detalhamento completo.",
  },
  status: {
    draft: "Rascunho",
    sent: "Emitida",
    processing: "Processando",
    pending: "Pendente",
    error: "Erro",
    corrected: "Corrigida",
    voided: "Anulada",
  },
  checkinModal: {
    title: "Detalhes do registro",
    bookingLink: "Reserva #{code}",
    requestDate: "Data da solicitação: {date} às {time}",
  },
  payment: {
    desti: "Pagar no destino",
    efect: "Dinheiro",
    movil: "Pagamento móvel",
    otro: "Outras formas de pagamento",
    platf: "Plataforma de pagamento",
    tarjt: "Cartão de crédito",
    trans: "Transferência bancária",
    treg: "Vale-presente",
  },
};
